/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSuggestedContacts} from '../api'

 export const useQueryGetSuggestedContacts = createReactQueryHook('getSuggestedContacts', getSuggestedContacts)
